/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Resource_Allocations_Status_EndedInputs */

const en_admin_resources_resource_allocations_status_ended = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

const de_admin_resources_resource_allocations_status_ended = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet`)
};

const es_admin_resources_resource_allocations_status_ended = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

const fr_admin_resources_resource_allocations_status_ended = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const nl_admin_resources_resource_allocations_status_ended = /** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beëindigd`)
};

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */
const it_admin_resources_resource_allocations_status_ended = en_admin_resources_resource_allocations_status_ended;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */
const pt_br2_admin_resources_resource_allocations_status_ended = en_admin_resources_resource_allocations_status_ended;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */
const pl_admin_resources_resource_allocations_status_ended = en_admin_resources_resource_allocations_status_ended;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */
const hu_admin_resources_resource_allocations_status_ended = en_admin_resources_resource_allocations_status_ended;

/** @type {(inputs: Admin_Resources_Resource_Allocations_Status_EndedInputs) => LocalizedString} */
const ro_admin_resources_resource_allocations_status_ended = en_admin_resources_resource_allocations_status_ended;

/**
* | output |
* | --- |
* | "Ended" |
*
* @param {Admin_Resources_Resource_Allocations_Status_EndedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_resource_allocations_status_ended = /** @type {((inputs?: Admin_Resources_Resource_Allocations_Status_EndedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Resource_Allocations_Status_EndedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "de") return de_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "es") return es_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "fr") return fr_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "nl") return nl_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "it") return it_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "pl") return pl_admin_resources_resource_allocations_status_ended(inputs)
	if (locale === "hu") return hu_admin_resources_resource_allocations_status_ended(inputs)
	return ro_admin_resources_resource_allocations_status_ended(inputs)
});
export { admin_resources_resource_allocations_status_ended as "admin.resources.resource_allocations.status_ended" }